// 引入axios请求方法
import { fun_GetAction, fun_UploadImg } from "@/api";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      isShow: "2", // disabled状态
      drawerStatus: false, // dialog弹框状态
      loading: false, // 抽屉确定按钮loading状态
      releasePathFlag: false, // 跳转链接显示标志
      contentFlag: true, // 文章内容显示标志
      photoPathFlag: false, // 图片路径显示标志
      lookPhotoFlag: false, // 查看按钮显示
      photoDialogFlag: false, // 图片弹窗显示
      // 自定义属性多选框数据
      articleSelect: [
        { name: "头条", value: "t" },
        { name: "置顶", value: "d" },
        { name: "跳转", value: "j" },
        { name: "图片", value: "p" }
      ],
      // 表单对象
      form: {
        id: null, // 主键id
        articleTitle: null, // 文章标题
        briefTitle: null, // 简略标题
        articleAttribute: [], // 自定义属性
        photoPath: null, // 图片新闻
        releasePath: null, // 跳转链接
        columnCode: null, // 所属栏目
        articleSource: null, // 文章来源
        author: null, // 作者
        articleContent: null // 文章内容
      },
      files: null, // 文件
      photoName: null, // 图片新闻
      imgSrc: null, // 图片路径
      // 验证规则
      rules: {
        // 文章标题
        articleTitle: [
          { required: true, message: "请填写文章标题", trigger: "blur" }
        ],
        // 简略标题
        briefTitle: [
          { required: true, message: "请填写简略标题", trigger: "blur" }
        ],
        // 所属栏目
        columnCode: [
          { required: true, message: "请选择所属栏目", trigger: "change" }
        ]
      },
      // 后台验证规则
      errRules: {
        articleTitle: null, // 文章标题
        briefTitle: null, // 简略标题
        articleAttribute: null, // 自定义属性
        photoPath: null, // 图片新闻
        releasePath: null, // 跳转链接
        columnCode: null, // 所属栏目
        articleSource: null, // 文章来源
        author: null, // 作者
        articleContent: null // 文章内容
      },
      // 所属栏目级联选择器数据
      options: [],
      // 设置所属栏目级联选择器属性
      optionProps: {
        value: "id",
        label: "columnName"
      }
    };
  },

  // 自定义方法
  methods: {
    /**
     * 抽屉打开时执行
     * @author 滕威
     */
    drawerOpen() {
      // 获取所属栏目数据方法
      this.fun_GetPressColumn();
    },
    /**
     * 修改
     * @author 滕威
     */
    fun_Edit(id) {
      this.fun_GetDetails(id);
    },
    /**
     * 获取所属栏目数据
     * @author 滕威
     */
    async fun_GetPressColumn() {
      let res = await fun_GetAction("/category/ArticleParentIdCombox");
      this.options = res.data.data;
    },
    /**
     * 处理所属栏目最后一级后台返回[]
     * @author 滕威
     */
    // fun_GetTreeData(data) {
    //   data.forEach(item => {
    //     // children不为[]，则递归调用
    //     if (item.children) this.fun_GetTreeData(item.children);
    //   });
    //   // 返回数据参数
    //   return data;
    // },
    /**
     * 所属栏目change事件
     * @author 滕威
     */
    fun_HandleColumn(value) {
      // 获取选中id
      if (value.length > 1) {
        this.form.columnCode = value[1];
      } else {
        this.form.columnCode = value[0];
      }
    },
    /**
     * 获取详情
     * @param id 主键
     * @author 滕威
     */
    async fun_GetDetails(id) {
      let res = await fun_GetAction("/article/detail?id=" + id);
      const { result, data, msg } = res.data;
      if (result) {
        this.form = data;
        // 多选框
        this.form.articleAttribute = this.form.articleAttribute.split(",");
        this.photoName = this.form.photoName;
        // 图片和跳转链接是否显示
        this.fun_PhotoInit();
      } else {
        this.$message.error(msg);
      }
    },
    /**
     * 图片和跳转链接是否显示
     * @author 滕威
     */
    fun_PhotoInit() {
      // 存在图片属性
      if (this.form.articleAttribute.indexOf("p") > -1) {
        this.photoPathFlag = true;
        // 如果存在图片显示，否则隐藏
        if (this.form.photoPath != null && this.form.photoPath != "") {
          this.lookPhotoFlag = true;
        } else {
          this.lookPhotoFlag = false;
        }
      } else {
        this.photoPathFlag = false;
        this.lookPhotoFlag = false;
      }
      // 存在跳转路径
      if (this.form.articleAttribute.indexOf("j") > -1) {
        this.releasePathFlag = true;
        this.contentFlag = false;
      } else {
        this.releasePathFlag = false;
        this.contentFlag = true;
      }
    },
    /**
     * 保存
     * @author 滕威
     */
    fun_SubmitForm() {
      if (this.loading) {
        return;
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 打开loading
          this.loading = true;
          if (
            this.form.articleAttribute.indexOf("p") > -1 &&
            this.photoName === null
          ) {
            this.$message.warning("请上传图片！");
            // 关闭保存按钮loading
            this.loading = false;
            return false;
          } else if (this.files && this.files.size / 1024 / 1024 > 1) {
            // 消息提示
            this.$message.warning("图片文件不能大于1M！");
            // 关闭保存按钮loading
            this.loading = false;
            return false;
          } else {
            delete this.form.insertDate;
            delete this.form.updateDate;
            // 创建form表单对象
            let formData = new FormData();
            for (const key in this.form) {
              if (this.form[key] !== null && this.form[key] !== "null") {
                formData.append(key, this.form[key]);
              }
            }
            // 模板文件
            formData.append("file", this.files);
            fun_UploadImg("/article/saveOrUpdate", formData).then(res => {
              const { result, msg, validation } = res.data;
              if (result) {
                // 关闭保存按钮loading
                this.loading = false;
                // 关闭抽屉
                this.$refs.drawer.closeDrawer();
                // 执行一览表格方法
                this.$parent.fun_GetList();
                // 清空表单内所有规则提示
                this.$nextTick(() => {
                  this.$refs["form"].clearValidate();
                });
                this.fun_ResetFields();
                // 成功提示
                this.$message.success(msg);
              } else {
                // 关闭保存按钮loading
                this.loading = false;
                if (msg) this.$message.error(msg);
                if (validation) {
                  // 如果不为空，则在页面提示
                  // 定义errRules为一个随机数
                  this.errRules = Math.random();
                  this.$nextTick(() => {
                    this.errRules = validation;
                  });
                }
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    /**
     * 多选框改变时函数
     * @author 滕威
     */
    fun_HandleCheckedChange(val) {
      // 是否选择了跳转
      if (val.indexOf("j") > -1) {
        // 跳转框显示
        this.releasePathFlag = true;
        // 文本框隐藏
        this.contentFlag = false;
        // 文本框内容
        this.form.articleContent = "/";
      } else {
        // 跳转框显示
        this.releasePathFlag = false;
        // 文本框显示
        this.contentFlag = true;
      }
      // 是否选择了跳转
      if (val.indexOf("p") > -1) {
        // 跳转框显示
        this.photoPathFlag = true;
      } else {
        // 跳转框显示
        this.photoPathFlag = false;
      }
    },
    /**
     * 图片弹窗关闭
     * @author 滕威
     */
    fun_PhotoHDialogClose() {
      // 弹窗隐藏
      this.photoDialogFlag = false;
      // 清空图片值
      this.imgSrc = null;
    },

    /**
     * 获取文件事件
     * @param event dom元素
     * @author 滕威
     */
    fun_UploadChange(file) {
      // 限制小于20M
      const is20M = file.size / 1024 / 1024 < 20;
      // 判断文件是否小于20MB
      if (!is20M) {
        // 提示错误消息
        this.$message.error("上传的文件大小不可超过20MB");
        // 返回
        return false;
      }
      // 获取文件对象
      this.files = file.raw;
      // 图片名称赋值
      this.photoName = file.name;
      // 清空图片路径
      this.form.photoPath = null;
    },
    /**
     * 上传按钮点击事件
     * @author 滕威
     */
    fun_HandleSelectFile() {
      document.getElementById("photoPath").click();
    },
    /**
     * dialog取消按钮
     * @author 滕威
     */
    fun_ResetForm() {
      // 清空表单对象
      this.fun_ResetFields();
      // 清空后台校验规则对象
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
      // 关闭dialog弹框
      this.drawerStatus = false;
      this.$parent.$refs.multipleTable.count++;
      this.loading = false;
    },
    /**
     * dialog弹框关闭时执行
     * @author 滕威
     */
    fun_HandleClose(done) {
      done();
      // 清空表单对象
      this.fun_ResetFields();
      // 清空后台校验规则对象
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    /**
     * 清空表单方法
     * @author 滕威
     */
    fun_ResetFields() {
      this.form = {
        id: null, // 主键id
        articleTitle: null, // 文章标题
        briefTitle: null, // 简略标题
        articleAttribute: [], // 自定义属性
        photoPath: null, // 图片新闻
        releasePath: null, // 跳转链接
        columnCode: null, // 所属栏目
        articleSource: null, // 文章来源
        author: null, // 作者
        articleContent: null // 文章内容
      };
      this.errRules = {
        articleTitle: null, // 文章标题
        briefTitle: null, // 简略标题
        articleAttribute: null, // 自定义属性
        photoPath: null, // 图片新闻
        releasePath: null, // 跳转链接
        columnCode: null, // 所属栏目
        articleSource: null, // 文章来源
        author: null, // 作者
        articleContent: null // 文章内容
      };
    },
    drawerClose() {
      this.photoName = null;
    }
  }
};
